<template>
  <div class="wrapper">
    <div class="bxslider">
      <transition-group :style="{height: '476px'}" tag="div" class="clearfix" @enter="enter" @after-enter="leave" :name=defaultDirection>
        <ul class="commandList clearfix" v-for="n in 3" :key="n" v-show="n===mark">
          <li class="commandItem l" v-for="(item, index) in commandList.slice((n-1)*6,n*6)" :key="index"
              @click="intoBooksDetail(item.id,'ebook')">
            <img v-bind:src="imgPath+item.image" :onerror="imgError" width="120" height="162">
            <div class="bookinfo r">
              <div class="itemName" :title="item.bookName">{{item.bookName.length>14?item.bookName.slice(0,12)+'...':item.bookName}}</div>
              <div class="itemAuthor ellip" :title="item.author">作者 : {{item.author}}</div>
              <div class="commamdInfo">
                <div class="commandIco">荐</div> {{item.recommendReason.length>34?item.recommendReason.slice(0,33)+'...':item.recommendReason}}</div>
            </div>
          </li>
        </ul>
      </transition-group>
    </div>
    <div class="button-prev" @click="changeDirection('prev')"></div>
    <div class="button-next" @click="changeDirection('next')"></div>
    <div class="lunbo_Ico">
      <div class="ico" @click="to(n)" v-for="n in (commandList.length/6)" :class="{center:n==2,ico_active:n==mark}" :key="n"></div>
    </div>
  </div>
</template>

<script>
  import {store} from '../store/store'
  import {imgPath} from "../common/config";
  export default {
    name: 'lunbo',
    props: ['commandList'],
    data() {
      return {
        mark: 1,
        move: false,
        timer: null,
        prev: "prev",
        next: "next",
        defaultDirection: "next",
        imgError: store.imgError,
        imgPath:imgPath
      }
    },
    created() {
//      this.play()
    },
    methods: {
      to(n) {
        if(this.move) {
          return false
        }
        if(n>this.mark) {
          this.defaultDirection = 'next';
        }else {
          this.defaultDirection = 'prev';
        }
        this.mark=n;
      },
      changeDirection:function(direction) {
        if(this.move) {
          return false
        }
        this.defaultDirection = direction;
        if(direction=='next') {
          this.mark++;
          if(this.mark == 4) {
            this.mark = 1;
          }
        }else {
          this.mark--;
          if(this.mark == 0) {
            this.mark = 3;
          }
        }
      },
      enter:function() {
        this.move = true;
      },
      leave:function() {
        this.move = false;
      },
      intoBooksDetail:function (id,type) {
        this.$emit('intoBooksDetail',id,type);
      }
    }
  }
</script>

<style scoped lang="sass">
  $themeColor : #BB6B32
  .next-enter-active
    transform: translateX(0)
    transition: all .8s ease

  .next-leave-active
    transform: translateX(-100%)
    transition: all .8s ease


  .next-enter
    transform: translateX(100%)


  .next-leave
    transform: translateX(0)

  .prev-enter-active
    transform: translateX(0)
    transition: all .8s ease

  .prev-leave-active
    transform: translateX(100%)
    transition: all .8s ease


  .prev-enter
    transform: translateX(-100%)


  .prev-leave
    transform: translateX(0)

  .wrapper
    position: relative
    padding-left: 56px
    overflow: hidden

  .imgWrapper
    position: relative
    width: 100%
    height: 100%

  .showImg
    position: absolute
    top: 0
    left: -100%
    height: 100%

  .prev, .next
    width: 28px
    height: 28px
    line-height: 28px
    text-align: center
    color: #fff
    background: rgba(0, 0, 0, 0.5)
    cursor: pointer
    user-select: none


  .prev
    position: absolute
    top: 50%
    left: 9px
    margin-top: -14px


  .next
    position: absolute
    top: 50%
    right: 9px
    margin-top: -14px

  .dotWrapper
    width: 100%
    height: 10px
    position: absolute
    bottom: 16px
    text-align: center

    /*电子书推荐*/
  .ebookCommand
    background-image: none
    .itemName
      line-height: 26px
    .commandList
      position: absolute
      width: 866px
      padding-top: 52px

  .commandTitle
    height: 60px
    line-height: 60px
    border-bottom: 1px solid #ececec

  .commandTitle h3
    width: 110px
    font-size: 18px
    font-weight: 500
    color: #333

  .ebookLabel
    display: inline-block
    vertical-align: middle
    margin: 0 auto
    overflow: hidden

  .ebookLabel .label
    margin-right: 14px
    padding: 0 12px
    height: 22px
    line-height: 22px
    background: $themeColor
    border-radius: 12px
    font-size: 14px
    color: #fff

  .ebookLabel .label:hover
    background: $themeColor

  .commandItem
    margin:
      right: 33px
      bottom: 50px
    width: 120px+110px+18px
    height: 162px
    cursor: pointer
    .bookinfo
      width: 110px
    .commamdInfo
      margin-top: 2px
      font-size: 12px
      line-height: 22px
      color: #808080
      .commandIco
        display: inline-block
        width: 21px
        height: 18px
        line-height: 18px
        text-indent: 6px
        color: #fff
        background: url("../assets/images/commandIco.png") no-repeat
        word-break: break-all

  .commandItem:hover .itemName
    color: $themeColor
    text-decoration: underline

  .commandItem img:hover
    opacity: 0.8

  .itemName
    margin-top: 6px
    font-size: 14px
    line-height: 26px
    color: #333333

  .itemAuthor
    margin-top: 6px
    font-size: 12px
    line-height: 18px
    color: #a1a1a1

  .hotTitle
    line-height: 72px
    font-size: 18px
    font-weight: 500

  .hotList
    padding: 0 0 40px 0
    width: 270px
    border: 1px solid #ececec

  .hotList .active
    padding: 10px 0

  .hotList .index
    padding-left: 20px

  .hotList .bookName
    padding-right: 30px
  %button
    position: absolute
    top: 212px
    width: 16px
    height: 62px
    cursor: pointer
  .button-next
    @extend %button
    right: 0
    background: url("../assets/images/commadn_next.png") no-repeat
    &:hover
      background: url("../assets/images/commadn_next_hover.png") no-repeat
  .button-prev
    @extend %button
    left: 0
    background: url("../assets/images/command_prev.png") no-repeat
    &:hover
      background: url("../assets/images/command_prev_hover.png") no-repeat
  .lunbo_Ico
    padding-top: 10px
    height: 16px
    text-align: center
  .ico
    vertical-align: top
    display: inline-block
    width: 52px
    height: 6px
    background: #efefef
    cursor: pointer
  .ico_active
    @extend .ico
    background: $col_cb
  .center
    margin: 0 16px
</style>
